import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  Renderer2,
  viewChild
} from '@angular/core';
import { fromFetch } from 'rxjs/fetch';
import { catchError, EMPTY, mergeMap, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ErrorComponent implements OnInit {
  readonly errorType = input('');

  readonly errorContainer = viewChild<ElementRef>('errorContainer');

  readonly #renderer = inject(Renderer2);

  hasError = false;

  ngOnInit(): void {
    this.loadTemplate().subscribe();
  }

  //#region Private methods

  private loadTemplate(): Observable<string> {
    return fromFetch(`/assets/error-pages/${this.errorType()}.html`).pipe(
      mergeMap(res => {
        if (!res.ok) {
          throw new Error();
        }

        return res.text();
      }),
      tap(data => {
        this.processTemplate(data);
      }),
      catchError(() => {
        this.hasError = true;

        return EMPTY;
      })
    );
  }

  private processTemplate(data: string): void {
    const div = this.#renderer.createElement('div') as HTMLElement;
    this.#renderer.setProperty(div, 'innerHTML', data);
    this.#renderer.appendChild(this.errorContainer()?.nativeElement, div);
  }

  //#endregion
}
